import { service } from '@/common/request/request.js'

// /uploadFile 上传文件

/*站内信**********************************************************************************************************/
// 获取站内信列表,返回消息记录总数total就是未读或者已读的数量
export function getMsgSiteList(data = {}) {
  return service({
    url: '/loged/getMsgSiteList',
    method: 'post',
    data
  })
}

// 更新站内信是否已读
export function updateMsgSite(data = {}) {
  return service({
    url: '/loged/updateMsgSite',
    method: 'post',
    data
  })
}

// 删除站内信
export function deleteMsgSite(data = {}) {
  return service({
    url: '/loged/deleteMsgSite',
    method: 'post',
    data
  })
}

// 会员推送站内信
export function sendMsgSite(data = {}) {
  return service({
    url: '/loged/insertMsgSite',
    method: 'post',
    data
  })
}

/*签到**************************************************************************************************************/
// 返回当前用户的签到信息
export function getUserCheckInfo(data = {}) {
  return service({
    url: '/loged/userCheckInfo',
    method: 'post',
    data
  })
}

// 签到
export function checkIn(data = {}) {
  return service({
    url: '/loged/checkin',
    method: 'post',
    data
  })
}

// 用户签到抽奖
export function checkInDraw(data = {}) {
  return service({
    url: '/loged/lottery',
    method: 'post',
    data
  })
}


// 获取所有banner列表
export function getBannerList(data = {}) {
  return service({
    url: '/guest/bannerList',
    method: 'post',
    data
  })
}

// 获取所有一级导航
export function getFirstNavList(data = {}) {
  return service({
    url: '/guest/firstNavList',
    method: 'post',
    data
  })
}

// 公告
export function getPushInfoList(data = {}, type = 0) {
  const url = ['/guest/pushInfoList', '/guest​/pushInfoListNoPage']
  return service({
    url: url[type],
    method: 'post',
    data
  })
}

// 获取推送通知
export function getPushList(data = {}, type = 0) {
  // 0 获取当前时间的推送通知--未登录 1 获取所有推送和通知 -- 登录
  const url = ['/guest/pushInfo', '/loged​/pushInfo']
  return service({
    url: url[type],
    method: 'post',
    data
  })
}

// 获取排行榜TOP10
export function getLeaderboard(data = {}) {
  return service({
    url: '/guest/leaderboard/query',
    method: 'post',
    data
  })
}

// 获取公益视频
export function getGoodVedio(data = {}) {
  return service({
    url: '/guest/leaderboard/getGoodVedio',
    method: 'post',
    data
  })
}

// 获取VIP等级
export function getVIpList(data = {}) {
  return service({
    url: '/guest/vipinfo/showVIpInfo',
    method: 'post',
    data
  })
}

// 根据vip等级获取vip的特权信息
export function getVIpInfo(data = {}) {
  return service({
    url: '/guest/vipPrivilege',
    method: 'post',
    data
  })
}

// 我的收藏
export function getMyCollection(data = {}) {
  return service({
    url: '/loged/myCollection',
    method: 'post',
    data
  })
}


/*邀请*******************************************************************************/
// 获取邀请码
export function getInviteCode(data = {}) {
  return service({
    url: '/loged/inviteCode',
    method: 'post',
    data
  })
}

// 获取邀请列表
export function getInviteList(data = {}) {
  return service({
    url: '/loged/inviteList',
    method: 'post',
    data
  })
}

// 邀请列表点击领取奖金按钮，领取奖金
export function getInviteBonus(data = {}) {
  return service({
    url: '/loged/getInviteBonus',
    method: 'post',
    data
  })
}

/*大转盘*************************************************************************************************/
// 大转盘抽奖初始化 未登录
export function getWheelInfo(data = {}) {
  return service({
    url: '/activity/guest/queryRaffle',
    method: 'post',
    data
  })
}

// 大转盘抽奖 已登录
export function rotaryDraw(data = {}) {
  return service({
    url: '/activity/raffle',
    method: 'post',
    data
  })
}

// 大转轮历史记录
export function getWheelRecordList(data = {}) {
  return service({
    url: '/activity/queryHistoryWin',
    method: 'post',
    data
  })
}

/*文章*********************************************************************************************************/
// 根据文章id获取文章
export function getArticleById(data = {}) {
  return service({
    url: '/guest/articleById',
    method: 'post',
    data
  })
}

// 根据文章类型获取文章列表
export function getArticleListByType(data = {}) {
  return service({
    url: '/guest/articleListByType',
    method: 'post',
    data
  })
}

// 获取文章类型
export function getArticleType(data = {}) {
  return service({
    url: '/guest/articleType',
    method: 'post',
    data
  })
}

// 获取首页弹框图片组
export function getfetchImg(data = {}) {
  return service({
    url: '/guest/fetchImg',
    method: 'post',
    data
  })
}


//新增921首页大奖列表接口
export function getGameBigWinList(data = {}) {
  return service({
    url: '/game/guest/gameBigWinList',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/common/api/normal.js